// Filter and Sorting Configuration Constants

export const operators = {
  contains: 'Contains',
  not_contains: 'Not contains',
  '>=': '>=',
  '<=': '<=',
  '>': '>=',
  '<': '<',
  '!=': '!=',
  '==': '==',
};

export const possibleFilters = {
  title: {
    label: 'Title',
    operators: ['contains', 'not_contains', '=='],
  },
  'genres.name': {
    label: 'Genres',
    operators: ['contains', 'not_contains'],
  },
  runtime: {
    label: 'Runtime',
    operators: ['>=', '<=', '==', '!=', '>', '<'],
  },
  release_date: {
    label: 'Release date',
    operators: ['>=', '<=', '==', '!=', '>', '<'],
  },
  release_year: {
    label: 'Release year',
    operators: ['>=', '<=', '==', '!=', '>', '<'],
  },
  average_rating: {
    label: 'Average rating',
    operators: ['>=', '<=', '==', '!=', '>', '<'],
  },
  user_average_rating: {
    label: 'User average rating',
    operators: ['>=', '<=', '==', '!=', '>', '<'],
  },
  my_rating: {
    label: 'My rating',
    operators: ['>=', '<=', '==', '!=', '>', '<'],
  },
  _ratedBy: {
    label: 'Rated by',
    operators: ['contains', 'not_contains'],
  },
  _watchlistedBy: {
    label: 'Watchlisted by',
    operators: ['contains', 'not_contains'],
  },
};

export const possibleSortings = {
  title: { label: 'Title' },
  release_date: { label: 'Release date' },
  release_year: { label: 'Release year' },
  average_rating: { label: 'Average rating' },
  user_average_rating: { label: 'User average rating' },
  my_rating: { label: 'My rating' },
  runtime: { label: 'Runtime' },
};

export const fieldTypes = {
  average_rating: 'number',
  user_average_rating: 'number',
  my_rating: 'number',
  release_date: 'date',
  release_year: 'number',
  genres: 'array',
};
